/**
 * Shared React Bootstrap
 * Ensures React and ReactDOM are loaded ONCE to window
 * All FilePond uploader components should import this
 */
import React from 'react';
import { createRoot } from 'react-dom/client';

// Only set if not already set (prevents multiple React instances)
if (!window.React) {
    window.React = React;
    console.log('✅ Shared React loaded');
}

if (!window.ReactDOM) {
    window.ReactDOM = { createRoot };
    console.log('✅ Shared ReactDOM loaded');
}

export { React, createRoot };
